<template>
    <a-modal
        centered
        title="更改/分配销售"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="540"
        :confirmLoading="submitting"
        :after-close="after_close"
        :ok_text="user_id ? '确定' : '取消所选客户的跟进人'"
    >
        <a-alert message="请注意：更改订单销售将会影响到该销售的业绩计算。" type="info" show-icon style="margin-bottom:24px;"/>



        <div class="ids">已选择：{{ record.map((v) => v.name).join("，") }}（共{{ record.length }}个订单）</div>

        <a-divider>更改为</a-divider>

        <a-checkable-tag
            :checked="item.id == user_id"
            class="r-checkbox checkbox-tag"
            v-for="item in basic_data_user"
            @change="on_click(item)"
            :key="item.id"
            >{{ item.name }}</a-checkable-tag
        >
    </a-modal>
</template>
<script>
    import basic_data from "../../../mixins/basic_data";
    export default {
        mixins: [basic_data],
        data() {
            return {
                user_id: null,
                submitting: false,
                visible: false,
                callback: null,
                record: [],
            };
        },
        mounted() {
            this.load_basic_user();
        },
        created() {
            this.$event_bus.$on("visible_order_distribute", (record, user_id, callback) => {
                this.visible = true;

                this.record = record;
                this.callback = callback;

                this.user_id = user_id;
            });
        },
        methods: {
            on_ok() {
                this.submitting = true;
                this.$http
                    .post(`/order_trademark/distribute`, {
                        user_id: this.user_id,
                        order_nos: this.record.map((v) => v.order_no),
                    })
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.user_id = null;
            },
            on_cancel() {
                this.visible = false;
            },
            on_click(e) {
                this.user_id = e.id;
            },
        },
    };
</script>
<style lang="less" scoped>
    .r-checkbox {
        cursor: pointer;
        margin-bottom: 12px;
    }
    .ids {
        font-size: 12px;
    }
</style>
